<template>
  <subpage-shell
    :eyebrow="trans.get('landing.subpages.so_funktioniert.eyebrow')"
    :title-prefix="trans.get('landing.subpages.so_funktioniert.title_prefix')"
    :title-grad="trans.get('landing.subpages.so_funktioniert.title_grad')"
    :title-suffix="trans.get('landing.subpages.so_funktioniert.title_suffix')"
    :cta-lede="trans.get('landing.subpages_shared.cta_lede_quiz_match')"
    nav-active="how-it-works"
  >
    <main class="prose">
      <h2>{{ trans.get('landing.subpages.so_funktioniert.prose.h2_idea') }}</h2>
      <p>
        {{ trans.get('landing.subpages.so_funktioniert.prose.p1') }}
      </p>

      <h2>{{ trans.get('landing.subpages.so_funktioniert.prose.h2_match') }}</h2>
      <p>
        {{ trans.get('landing.subpages.so_funktioniert.prose.p2') }}
      </p>

      <h2>{{ trans.get('landing.subpages.so_funktioniert.prose.h2_why') }}</h2>
      <p>
        {{ trans.get('landing.subpages.so_funktioniert.prose.p3') }}
      </p>

      <h2>{{ trans.get('landing.subpages.so_funktioniert.prose.h2_offer') }}</h2>
      <p>
        {{ trans.get('landing.subpages.so_funktioniert.prose.p4') }}
      </p>

      <h2>{{ trans.get('landing.subpages.so_funktioniert.prose.h2_not') }}</h2>
      <p>
        {{ trans.get('landing.subpages.so_funktioniert.prose.p5') }}
      </p>

      <h2>{{ trans.get('landing.subpages.so_funktioniert.prose.h2_start') }}</h2>
      <p>
        {{ trans.get('landing.subpages.so_funktioniert.prose.p6') }}
      </p>
    </main>

    <section
      class="sec reveal"
      id="how"
    >
      <div class="sec-head-row">
        <div>
          <span class="sec-eyebrow">{{ trans.get('landing.how.eyebrow') }}</span>
          <h2 class="sec-title">
            {{ trans.get('landing.how.title_line1') }}<br />
            {{ trans.get('landing.how.title_line2_prefix')
            }}<span class="grad">{{ trans.get('landing.how.title_line2_grad') }}</span
            ><span class="title-dot">{{ trans.get('landing.how.title_line2_dot') }}</span>
          </h2>
        </div>
        <p class="sec-lede sec-lede--tight">
          {{ trans.get('landing.how.lede') }}
        </p>
      </div>

      <div class="how">
        <div class="step">
          <div class="num">{{ trans.get('landing.how.step1_num') }}</div>
          <h3>{{ trans.get('landing.how.step1_title') }}</h3>
          <p>{{ trans.get('landing.how.step1_text') }}</p>
          <div class="vis">
            <div class="vis-profile">
              <div class="av av--lena"></div>
              <div class="nm">{{ trans.get('landing.how.step1_profile_name') }}</div>
              <div class="age">{{ trans.get('landing.how.step1_profile_age') }}</div>
              <div class="tags">
                <span class="tag">{{ trans.get('landing.how.step1_tag_1') }}</span>
                <span class="tag">{{ trans.get('landing.how.step1_tag_2') }}</span>
                <span class="tag">{{ trans.get('landing.how.step1_tag_3') }}</span>
              </div>
            </div>
            <span class="chip chip--verified">
              <span class="chip-check"><icon-check :size="11" /></span>
              <span class="chip-label">{{ trans.get('landing.how.step1_verified') }}</span>
            </span>
          </div>
        </div>

        <div class="step">
          <div class="num">{{ trans.get('landing.how.step2_num') }}</div>
          <h3>{{ trans.get('landing.how.step2_title') }}</h3>
          <p>{{ trans.get('landing.how.step2_text') }}</p>
          <div class="vis">
            <div class="vis-quiz">
              <div class="q">{{ trans.get('landing.how.step2_q') }}</div>
              <div class="opt">{{ trans.get('landing.how.step2_opt_1') }}</div>
              <div class="opt right">{{ trans.get('landing.how.step2_opt_2') }}</div>
              <div class="opt">{{ trans.get('landing.how.step2_opt_3') }}</div>
            </div>
          </div>
        </div>

        <div class="step">
          <div class="num">{{ trans.get('landing.how.step3_num') }}</div>
          <h3>{{ trans.get('landing.how.step3_title') }}</h3>
          <p>{{ trans.get('landing.how.step3_text') }}</p>
          <div class="vis">
            <div class="vis-chat">
              <div class="b them">{{ trans.get('landing.how.step3_msg_1') }}</div>
              <div class="b me">{{ trans.get('landing.how.step3_msg_2') }}</div>
              <div class="b them">{{ trans.get('landing.how.step3_msg_3') }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      class="sec reveal"
      id="chat-experience"
    >
      <div class="chat-exp-grid">
        <div class="chat-exp-copy">
          <span class="sec-eyebrow">{{
            trans.get('landing.subpages.so_funktioniert.chat_exp.eyebrow')
          }}</span>
          <h2 class="sec-title">
            {{ trans.get('landing.subpages.so_funktioniert.chat_exp.title_prefix') }}<br />{{
              trans.get('landing.subpages.so_funktioniert.chat_exp.title_middle')
            }}
            <span class="grad">{{
              trans.get('landing.subpages.so_funktioniert.chat_exp.title_grad')
            }}</span>
            {{ trans.get('landing.subpages.so_funktioniert.chat_exp.title_suffix') }}
          </h2>
          <p class="sec-lede">
            {{ trans.get('landing.subpages.so_funktioniert.chat_exp.lede') }}
          </p>
          <div class="chat-exp-actions">
            <button
              type="button"
              class="btn-primary"
              @click="openSignup"
            >
              {{ trans.get('landing.subpages.so_funktioniert.chat_exp.cta') }}
              <span class="arrow">→</span>
            </button>
            <div class="chat-exp-trust">
              <div class="stack">
                <div class="av a1"></div>
                <div class="av a2"></div>
                <div class="av a3"></div>
                <div class="av a4"></div>
              </div>
              <span
                ><strong>{{
                  trans.get('landing.subpages.so_funktioniert.chat_exp.proof_strong')
                }}</strong>
                {{ trans.get('landing.subpages.so_funktioniert.chat_exp.proof_suffix') }}</span
              >
            </div>
          </div>
        </div>

        <div
          class="chat-exp-vis"
          aria-hidden="true"
        >
          <div class="ce-bubble-cluster">
            <div class="ce-float ce-f1">
              <icon-heart :size="14" />
            </div>
            <div class="ce-float ce-f2">
              <icon-heart :size="11" />
            </div>
            <div class="ce-float ce-f3">✨</div>
            <div class="ce-float ce-f4">💬</div>

            <div class="ce-card">
              <div class="ce-head">
                <div class="ce-av-row">
                  <div class="ce-av ce-av-1"></div>
                  <div class="ce-av ce-av-2"></div>
                  <div class="ce-av ce-av-3"></div>
                </div>
                <div class="ce-active">
                  <span class="ce-pulse"></span>
                  <span>{{
                    trans.get('landing.subpages.so_funktioniert.chat_exp.card_active_chats')
                  }}</span>
                </div>
              </div>

              <div class="ce-thread">
                <div class="ce-msg them m1">
                  <div class="ce-msg-av ce-av-1"></div>
                  <div class="ce-msg-bub">
                    {{ trans.get('landing.subpages.so_funktioniert.chat_exp.msg_1') }}
                  </div>
                </div>
                <div class="ce-msg me m2">
                  <div class="ce-msg-bub">
                    {{ trans.get('landing.subpages.so_funktioniert.chat_exp.msg_2') }}
                  </div>
                </div>
                <div class="ce-msg them m3">
                  <div class="ce-msg-av ce-av-1"></div>
                  <div class="ce-msg-bub">
                    {{ trans.get('landing.subpages.so_funktioniert.chat_exp.msg_3') }}
                  </div>
                </div>
                <div class="ce-msg me m4">
                  <div class="ce-msg-bub">
                    {{ trans.get('landing.subpages.so_funktioniert.chat_exp.msg_4') }}
                  </div>
                </div>
                <div class="ce-typing">
                  <div class="ce-msg-av ce-av-1"></div>
                  <div class="ce-typing-bub"><span></span><span></span><span></span></div>
                </div>
              </div>

              <div class="ce-input">
                <div class="ce-input-fld">
                  {{ trans.get('landing.subpages.so_funktioniert.chat_exp.input_ph') }}
                </div>
                <div class="ce-send">
                  <icon-send-plane-alt :size="14" />
                </div>
              </div>
            </div>

            <div class="ce-side-bubble ce-sb-1">
              <span
                class="ce-sb-avatar ce-sb-avatar--lena"
                aria-hidden="true"
              ></span>
              <div>
                <div class="ce-sb-ttl">
                  {{ trans.get('landing.subpages.so_funktioniert.chat_exp.sb1_title') }}
                </div>
                <div class="ce-sb-sub">
                  {{ trans.get('landing.subpages.so_funktioniert.chat_exp.sb1_sub') }}
                </div>
              </div>
            </div>
            <div class="ce-side-bubble ce-sb-2">
              <span class="ce-sb-emo">💬</span>
              <div>
                <div class="ce-sb-ttl">
                  {{ trans.get('landing.subpages.so_funktioniert.chat_exp.sb2_title') }}
                </div>
                <div class="ce-sb-sub">
                  {{ trans.get('landing.subpages.so_funktioniert.chat_exp.sb2_sub') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="sec reveal"
      id="sicherheit"
    >
      <div class="trust-grid">
        <div class="trust-vis">
          <div class="shield">
            <div class="check">
              <icon-check
                :size="40"
                :stroke-width="3"
              />
            </div>
          </div>
          <div class="badge-float b1">
            <div class="ic">
              <icon-lock-outline
                :size="14"
                :stroke-width="2"
              />
            </div>
            {{ trans.get('landing.trust.badge_dsgvo') }}
          </div>
          <div class="badge-float b2">
            <div class="ic ic--encrypted">
              <icon-check
                :size="14"
                :stroke-width="3"
              />
            </div>
            {{ trans.get('landing.trust.badge_encrypted') }}
          </div>
          <div class="badge-float b3">
            <div class="ic ic--privacy">
              <span class="ic-bg"></span>
              <span class="ic-veil"></span>
              <icon-lock-badge class="ic-lock" />
            </div>
            {{ trans.get('landing.trust.badge_privacy') }}
          </div>
        </div>

        <div class="trust-text">
          <span class="sec-eyebrow">{{ trans.get('landing.trust.eyebrow') }}</span>
          <h2 class="sec-title">
            {{ trans.get('landing.trust.title_line1') }}<br />{{
              trans.get('landing.trust.title_line2_prefix')
            }}<span class="grad">{{ trans.get('landing.trust.title_line2_grad') }}</span
            ><span class="title-dot">{{ trans.get('landing.trust.title_line2_suffix') }}</span>
          </h2>
          <p class="sec-lede sec-lede--tight">{{ trans.get('landing.trust.lede') }}</p>

          <div class="trust-list">
            <div class="trust-item">
              <div class="ic">
                <icon-check-circle
                  :size="20"
                  :stroke-width="2"
                />
              </div>
              <div>
                <h4>{{ trans.get('landing.trust.item1_title') }}</h4>
                <p>{{ trans.get('landing.trust.item1_text') }}</p>
              </div>
            </div>
            <div class="trust-item">
              <div class="ic">
                <icon-lock-outline
                  :size="20"
                  :stroke-width="2"
                />
              </div>
              <div>
                <h4>{{ trans.get('landing.trust.item2_title') }}</h4>
                <p>{{ trans.get('landing.trust.item2_text') }}</p>
              </div>
            </div>
            <div class="trust-item">
              <div class="ic">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path d="M12 2L4 6v6c0 5 3.5 9.5 8 10 4.5-.5 8-5 8-10V6l-8-4z" />
                </svg>
              </div>
              <div>
                <h4>{{ trans.get('landing.trust.item4_title') }}</h4>
                <p>{{ trans.get('landing.trust.item4_text') }}</p>
              </div>
            </div>
            <div class="trust-item">
              <div class="ic privacy-ic">
                <div class="pi-photos">
                  <div class="pi-photo pi-photo--lena"></div>
                  <div class="pi-photo pi-photo--sophia"></div>
                  <div class="pi-photo pi-photo--man1"></div>
                  <div class="pi-photo pi-photo--mia"></div>
                </div>
                <div class="pi-veil"></div>
                <span class="pi-lock"
                  ><icon-lock-badge
                    :size="18"
                    :stroke-width="2.4"
                /></span>
              </div>
              <div>
                <h4>{{ trans.get('landing.trust.item3_title') }}</h4>
                <p>{{ trans.get('landing.subpages.so_funktioniert.safety_photo_privacy') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </subpage-shell>
</template>

<script>
import SubpageShell from './SubpageShell.vue';
import IconHeart from '../../../../components/LandingV2/icons/IconHeart.vue';
import IconSendPlaneAlt from '../../../../components/LandingV2/icons/IconSendPlaneAlt.vue';
import IconCheck from '../../../../components/LandingV2/icons/IconCheck.vue';
import IconCheckCircle from '../../../../components/LandingV2/icons/IconCheckCircle.vue';
import IconLockOutline from '../../../../components/LandingV2/icons/IconLockOutline.vue';
import IconLockBadge from '../../../../components/LandingV2/icons/IconLockBadge.vue';

export default {
  name: 'SoFunktioniertPage',
  components: {
    SubpageShell,
    IconHeart,
    IconSendPlaneAlt,
    IconCheck,
    IconCheckCircle,
    IconLockOutline,
    IconLockBadge,
  },
  methods: {
    openSignup() {
      this.$eventHub.$emit('viluu-landing:open-signup', { mode: 'register' });
    },
  },
};
</script>
<style scoped lang="scss">
/* #how step cards (.how / .step / .vis-* / .chip family) are shared with
   HowItWorksSection and live in styles/landing.scss. */

.sec-lede--tight {
  margin-bottom: 0;
}

/* ---------- #sicherheit (subpage variant — shield, not safe-heart) ---------- */
.trust-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.trust-vis {
  position: relative;
  height: 480px;
  background: radial-gradient(circle at 50% 50%, #fff 0%, #fff5f0 60%, transparent 100%);
  border-radius: 32px;
  display: grid;
  place-items: center;
}

.shield {
  width: 220px;
  height: 260px;
  background: linear-gradient(135deg, var(--coral), var(--pink));
  border-radius: 50% 50% 38% 38% / 30% 30% 50% 50%;
  clip-path: path(
    'M110 0 C 60 12, 18 30, 18 80 C 18 180, 80 240, 110 260 C 140 240, 202 180, 202 80 C 202 30, 160 12, 110 0 Z'
  );
  display: grid;
  place-items: center;
  color: #fff;
  box-shadow: 0 40px 80px -30px rgba(198, 62, 124, 0.5);
  position: relative;
}

.shield::after {
  content: '';
  position: absolute;
  inset: 8px;
  background: linear-gradient(160deg, rgba(255, 255, 255, 0.3), transparent 50%);
  border-radius: inherit;
  clip-path: inherit;
  pointer-events: none;
}

.shield .check {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #fff;
  display: grid;
  place-items: center;
  color: var(--pink);
  box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 1;
}

.trust-vis .badge-float {
  position: absolute;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 14px 32px -12px rgba(26, 12, 20, 0.2);
  font-size: 12px;
  font-weight: 600;
}

.trust-vis .b1 {
  top: 40px;
  left: 30px;
  animation: bob 5s ease-in-out infinite;
}

.trust-vis .b2 {
  bottom: 60px;
  right: 20px;
  animation: bob 6s ease-in-out infinite -2s;
}

.trust-vis .b3 {
  top: 50%;
  right: -10px;
  animation: bob 5.5s ease-in-out infinite -3s;
}

.trust-vis .badge-float .ic {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  background: linear-gradient(135deg, #ffd2c2, #ff8a9e);
  display: grid;
  place-items: center;
  color: #fff;
}

.badge-float .ic.ic--encrypted {
  background: linear-gradient(135deg, #34d399, #16a34a);
  color: #fff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.35), 0 4px 10px -2px rgba(22, 163, 74, 0.4);
}

.badge-float .ic.ic--privacy {
  background: none;
  overflow: hidden;
  position: relative;
}

.badge-float .ic--privacy .ic-bg {
  position: absolute;
  inset: 0;
  background-image: image-set(
    url('../../../../../../images/viluu/landing-v2/profiles/lena.webp') type('image/webp'),
    url('../../../../../../images/viluu/landing-v2/profiles/lena.png')
  );
  background-size: cover;
  background-position: center;
  filter: blur(2.5px) saturate(1.1);
}

.badge-float .ic--privacy .ic-veil {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle, rgba(20, 5, 15, 0.12), rgba(20, 5, 15, 0.5));
}

.badge-float .ic--privacy .ic-lock {
  position: relative;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.55));
}

.trust-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 32px;
}

.trust-item {
  display: flex;
  gap: 14px;
  align-items: center;
  padding: 18px;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 18px;
}

.trust-item .ic {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(241, 124, 8, 0.12), rgba(198, 62, 124, 0.12));
  color: var(--pink);
  display: grid;
  place-items: center;
  flex-shrink: 0;
}

.trust-item h4 {
  margin: 0 0 4px;
  font-family: var(--display);
  font-size: 16px;
  font-weight: 700;
}

.trust-item p {
  margin: 0;
  font-size: 13px;
  color: var(--ink-dim);
  line-height: 1.5;
}

.trust-item .privacy-ic {
  width: 48px;
  height: 48px;
  padding: 0;
  background: transparent;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  flex-shrink: 0;
  box-shadow: 0 6px 14px -4px rgba(20, 5, 15, 0.18), 0 1px 0 rgba(255, 255, 255, 0.6) inset;
}

.privacy-ic .pi-photos {
  position: absolute;
  inset: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  filter: blur(4px) saturate(1.1);
}

.privacy-ic .pi-photo {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.pi-photo--lena {
  background-image: image-set(
    url('../../../../../../images/viluu/landing-v2/profiles/lena.webp') type('image/webp'),
    url('../../../../../../images/viluu/landing-v2/profiles/lena.png')
  );
}

.pi-photo--sophia {
  background-image: image-set(
    url('../../../../../../images/viluu/landing-v2/profiles/sophia-stories.webp') type('image/webp'),
    url('../../../../../../images/viluu/landing-v2/profiles/sophia-stories.png')
  );
}

.pi-photo--man1 {
  background-image: image-set(
    url('../../../../../../images/viluu/landing-v2/profiles/man-1.webp') type('image/webp'),
    url('../../../../../../images/viluu/landing-v2/profiles/man-1.png')
  );
}

.pi-photo--mia {
  background-image: image-set(
    url('../../../../../../images/viluu/landing-v2/profiles/mia.webp') type('image/webp'),
    url('../../../../../../images/viluu/landing-v2/profiles/mia.png')
  );
}

.privacy-ic .pi-veil {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at center, rgba(20, 5, 15, 0.1) 0%, rgba(20, 5, 15, 0.5) 100%);
}

.privacy-ic .pi-lock {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  color: #fff;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.5));
}

@media (max-width: 1100px) {
  .trust-grid {
    grid-template-columns: 1fr;
    gap: 50px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .trust-vis .badge-float {
    animation: none;
  }
}

.chat-exp-grid {
  display: grid;
  grid-template-columns: 0.95fr 1.05fr;
  gap: 80px;
  align-items: center;
}

.chat-exp-copy {
  max-width: 520px;
}

.chat-exp-copy .sec-lede {
  margin-bottom: 32px;
  text-wrap: pretty;
}

.chat-exp-actions {
  display: flex;
  flex-direction: column;
  gap: 22px;
  align-items: flex-start;
}

.chat-exp-trust {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 13px;
  color: var(--ink-dim);
}

.chat-exp-trust strong {
  color: var(--ink);
  font-weight: 700;
}

.chat-exp-trust .stack .av {
  width: 32px;
  height: 32px;
}

.chat-exp-vis {
  position: relative;
  min-height: 520px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ce-bubble-cluster {
  position: relative;
  width: 100%;
  max-width: 520px;
  height: 520px;
}

.ce-float {
  position: absolute;
  display: grid;
  place-items: center;
  font-size: 18px;
  width: 40px;
  height: 40px;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 14px 28px -10px rgba(198, 62, 124, 0.3), 0 4px 10px -2px rgba(26, 12, 20, 0.06);
  color: var(--pink);
  animation: bob 5s ease-in-out infinite;
}

.ce-float.ce-f1 {
  top: 6%;
  left: -4%;
  background: linear-gradient(135deg, var(--coral), var(--pink));
  color: #fff;
  width: 46px;
  height: 46px;
  border-radius: 16px;
  animation-delay: -1s;
}

.ce-float.ce-f2 {
  top: 18%;
  right: 6%;
  background: #fff;
  color: var(--pink);
  width: 34px;
  height: 34px;
  animation-delay: -2.5s;
}

.ce-float.ce-f3 {
  bottom: 18%;
  left: -2%;
  font-size: 20px;
  background: linear-gradient(135deg, #fff5d6, #ffd166);
  color: #7a3d00;
  animation-delay: -3s;
}

.ce-float.ce-f4 {
  bottom: 6%;
  right: -4%;
  font-size: 18px;
  background: #fff;
  animation-delay: -1.5s;
}

.ce-card {
  position: absolute;
  inset: 6% 8%;
  background: #fff;
  border-radius: 28px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 30px 70px -20px rgba(198, 62, 124, 0.35), 0 12px 26px -8px rgba(26, 12, 20, 0.12),
    0 1px 0 rgba(255, 255, 255, 0.9) inset;
  border: 1px solid rgba(255, 255, 255, 0.7);
  overflow: hidden;
  animation: cardIn 0.8s cubic-bezier(0.16, 1.4, 0.5, 1) 0.2s both;
}

.ce-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--line);
  margin-bottom: 14px;
}

.ce-av-row {
  display: flex;
}

.ce-av-row .ce-av {
  margin-left: -8px;
  border: 2.5px solid #fff;
  box-shadow: 0 2px 4px rgba(26, 12, 20, 0.1);
}

.ce-av-row .ce-av:first-child {
  margin-left: 0;
}

.ce-av {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}

.ce-av-1 {
  background-image: image-set(
    url('../../../../../../images/viluu/landing-v2/profiles/man-1.webp') type('image/webp'),
    url('../../../../../../images/viluu/landing-v2/profiles/man-1.png')
  );
  background-size: cover;
  background-position: center;
}

.ce-av-2 {
  background-image: image-set(
    url('../../../../../../images/viluu/landing-v2/profiles/man-2.webp') type('image/webp'),
    url('../../../../../../images/viluu/landing-v2/profiles/man-2.png')
  );
  background-size: cover;
  background-position: center 30%;
}

.ce-av-3 {
  background-image: image-set(
    url('../../../../../../images/viluu/landing-v2/profiles/man-3.webp') type('image/webp'),
    url('../../../../../../images/viluu/landing-v2/profiles/man-3.png')
  );
  background-size: cover;
  background-position: center 30%;
}

.ce-active {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--ink-dim);
}

.ce-pulse {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  animation: pulse 2s infinite;
  flex-shrink: 0;
}

.ce-thread {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  overflow: hidden;
}

.ce-msg {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  opacity: 0;
  animation: msgIn 0.55s cubic-bezier(0.16, 1.5, 0.5, 1) forwards;
}

.ce-msg.m1 {
  animation-delay: 0.6s;
}

.ce-msg.m2 {
  animation-delay: 1.4s;
}

.ce-msg.m3 {
  animation-delay: 2.4s;
}

.ce-msg.m4 {
  animation-delay: 3.3s;
}

.ce-msg.them {
  align-self: flex-start;
  flex-direction: row;
}

.ce-msg.me {
  align-self: flex-end;
  flex-direction: row-reverse;
}

.ce-msg .ce-msg-av {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-shrink: 0;
}

.ce-msg-bub {
  padding: 9px 13px;
  font-size: 12.5px;
  line-height: 1.4;
  border-radius: 14px;
  max-width: 78%;
}

.ce-msg.them .ce-msg-bub {
  background: #fbf3ef;
  color: var(--ink);
  border-bottom-left-radius: 4px;
}

.ce-msg.me .ce-msg-bub {
  background: linear-gradient(135deg, var(--coral), var(--pink));
  color: #fff;
  border-bottom-right-radius: 4px;
  box-shadow: 0 6px 14px -4px rgba(198, 62, 124, 0.4);
}

.ce-typing {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  align-self: flex-start;
  opacity: 0;
  animation: msgIn 0.55s ease forwards 4.1s;
}

.ce-typing .ce-msg-av {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-shrink: 0;
}

.ce-typing-bub {
  background: #fbf3ef;
  padding: 11px 14px;
  border-radius: 14px;
  border-bottom-left-radius: 4px;
  display: inline-flex;
  gap: 4px;
}

.ce-typing-bub span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--ink-mute);
  animation: typing 1.3s ease-in-out infinite;
}

.ce-typing-bub span:nth-child(2) {
  animation-delay: 0.15s;
}

.ce-typing-bub span:nth-child(3) {
  animation-delay: 0.3s;
}

.ce-input {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 8px 8px 14px;
  background: #fbf3ef;
  border-radius: 99px;
  margin-top: 14px;
}

.ce-input-fld {
  flex: 1;
  font-size: 12px;
  color: var(--ink-mute);
  font-style: italic;
}

.ce-send {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--coral), var(--pink));
  color: #fff;
  display: grid;
  place-items: center;
  box-shadow: 0 6px 14px -4px rgba(198, 62, 124, 0.5);
}

.ce-side-bubble {
  position: absolute;
  background: #fff;
  border-radius: 18px;
  padding: 11px 14px;
  display: flex;
  align-items: center;
  gap: 11px;
  box-shadow: 0 18px 36px -14px rgba(198, 62, 124, 0.3), 0 4px 10px -2px rgba(26, 12, 20, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.7);
  animation: bob 5s ease-in-out infinite, popIn 0.6s cubic-bezier(0.16, 1.4, 0.5, 1) both;
  z-index: 3;
}

.ce-side-bubble .ce-sb-emo {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: linear-gradient(135deg, #fff5d6, #ffe199);
  display: grid;
  place-items: center;
  font-size: 16px;
  flex-shrink: 0;
  box-shadow: inset 0 -2px 4px rgba(120, 60, 0, 0.15);
}

.ce-side-bubble .ce-sb-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px #fff, 0 4px 10px -2px rgba(198, 62, 124, 0.4);
  position: relative;
}

.ce-side-bubble .ce-sb-avatar::after {
  content: '';
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #22c55e;
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px rgba(34, 197, 94, 0.3);
}

.ce-side-bubble .ce-sb-ttl {
  font-size: 12px;
  font-weight: 700;
  color: var(--ink);
  line-height: 1.1;
}

.ce-side-bubble .ce-sb-sub {
  font-size: 10.5px;
  color: var(--ink-dim);
  margin-top: 3px;
}

.ce-sb-1 {
  top: -2%;
  right: -6%;
  animation-delay: -2s, 0.5s;
}

.ce-sb-1 .ce-sb-emo {
  background: linear-gradient(135deg, #ffd2c2, #ff8a9e);
  color: #fff;
}

.ce-sb-2 {
  bottom: -2%;
  left: -8%;
  animation-delay: -3s, 0.9s;
}

.ce-sb-2 .ce-sb-emo {
  background: linear-gradient(135deg, #c8a2ff, #8b5cf6);
  color: #fff;
}

.ce-sb-avatar--lena {
  background-image: image-set(
    url('../../../../../../images/viluu/landing-v2/profiles/lena.webp') type('image/webp'),
    url('../../../../../../images/viluu/landing-v2/profiles/lena.png')
  );
  background-size: cover;
  background-position: center;
}

@media (max-width: 1100px) {
  .chat-exp-grid {
    grid-template-columns: 1fr;
    gap: 50px;
  }
  .chat-exp-vis {
    min-height: 480px;
  }
  .ce-bubble-cluster {
    max-width: 440px;
    height: 480px;
    margin: 0 auto;
  }
}

@keyframes cardIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.96);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes msgIn {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.96);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
</style>
